import React from "react";
import { Composition, Folder } from "remotion";
import Furniture, {
  FurniturePropsSchema,
  calculateFurnitureMetadata,
} from "./Compostion/Furniture";
import { TopCountdown,
  TopCountdownPropsSchema,
} from "./Compostion/TopCountdown";
import { TwoUpSplitYoutube,
  TwoUpSplitYoutubePropsSchema,
  calculateMetadata,
} from "./Compostion/TwoUpSplitYoutube";
import Hair, { HairPropsSchema, calculateHairMetadata } from "./Video/Hair";
import AmazonShowcase, {
  AmazonShowcasePropsSchema,
  calculateAmazonShowcaseMetadata,
} from "./Video/AmazonShowcase";
import LandingPageComposition, {
  LandingPageCompositionPropsSchema,
  calculateLandingPageMetadata,
} from "./Compostion/LandingPageComposition";
import WigGlowUp, {
  WigGlowUpPropsSchema,
  calculateWigGlowUpMetadata,
} from "./Video/WigGlowUp";
import UnboxingOverview, {
  UnboxingOverviewPropsSchema,
  calculateUnboxingOverviewMetadata,
} from "./Compostion/UnboxingOverview";

export const RemotionRoot = () => {
  return (
    <>
      <Folder name="Influencer">
        <Composition
          id="HairVideo"
          width={1920}
          height={1080}
          fps={30}
          durationInFrames={1900} // Will be overridden by calculateHairMetadata
          schema={HairPropsSchema}
          calculateMetadata={calculateHairMetadata}
          defaultProps={{
            images: [
              { src: "https://m.media-amazon.com/images/I/71poim9nMzL._SY250_.jpg" },
              { src: "https://m.media-amazon.com/images/I/71MkomStCJL._SY250_.jpg" },
              { src: "https://m.media-amazon.com/images/I/71jW55oLTVL._SY250_.jpg" },
              { src: "https://m.media-amazon.com/images/I/71qHcMtDKdL._SY250_.jpg" },
              { src: "https://m.media-amazon.com/images/I/41QKHrIJPQL._SY250_.jpg" },
            ],
            imageSlides: [
              { src: "https://m.media-amazon.com/images/S/aplus-media-library-service-media/cadb0eca-d04e-4d8e-9ff2-8a1456ce4554.__CR0,0,970,600_PT0_SX970_V1___.png" },
              { src: "https://m.media-amazon.com/images/I/811YQtpb+EL._SL1500_.jpg" },
              { src: "https://m.media-amazon.com/images/I/71qHcMtDKdL.jpg" },
              { src: "https://m.media-amazon.com/images/I/71gK5ttQ0hL.jpg" },
            ],
            title: "Straight Lace Brazilian Wig",
            subtitle: "Transform Your Look",
            transitionDuration: 30,
            includeGrid: true,
            gridAnimationSeed: 123,
            finalShuffleCount: 3,
            finalShuffleSpeed: 2,
            audioVolume: 1,
            audioStartFrom: 0,
            audioDurationOverride: 52,
            audioSrc: "",
          }}
          component={Hair}
        />
        {/* Furniture Transition Demo */}
        <Composition
          id="AmazonShowcase"
          width={1920}
          height={1080}
          fps={30}
          durationInFrames={900}
          schema={AmazonShowcasePropsSchema}
          calculateMetadata={calculateAmazonShowcaseMetadata}
          defaultProps={{
            productTitle: "Premium Wireless Headphones",
            productSubtitle: "Noise Cancelling | 40hr Battery | Hi-Res Audio",
            heroImage:
              "https://m.media-amazon.com/images/I/71poim9nMzL._SY250_.jpg",
            price: "$79.99",
            originalPrice: "$129.99",
            rating: 4.7,
            reviewCount: "12,847 ratings",
            features: [
              { icon: "🎧", label: "Active Noise Cancelling" },
              { icon: "🔋", label: "40-Hour Battery Life" },
              { icon: "🎵", label: "Hi-Res Audio Certified" },
              { icon: "📱", label: "Multipoint Connection" },
              { icon: "🎤", label: "Crystal Clear Calls" },
              { icon: "💧", label: "IPX4 Water Resistant" },
            ],
            reviews: [
              {
                reviewer: "Sarah M.",
                text: "Best headphones I've ever owned. The noise cancelling is incredible!",
                rating: 5,
              },
              {
                reviewer: "Mike T.",
                text: "Great sound quality for the price. Battery lasts forever.",
                rating: 5,
              },
              {
                reviewer: "Jessica L.",
                text: "Very comfortable for long listening sessions. Highly recommend!",
                rating: 4,
              },
            ],
            galleryImages: [
              { src: "https://m.media-amazon.com/images/I/71poim9nMzL._SY250_.jpg" },
              { src: "https://m.media-amazon.com/images/I/71MkomStCJL._SY250_.jpg" },
              { src: "https://m.media-amazon.com/images/I/71jW55oLTVL._SY250_.jpg" },
              { src: "https://m.media-amazon.com/images/I/71qHcMtDKdL._SY250_.jpg" },
            ],
            gridImages: [],
            verdictScore: "9.4",
            verdictLabel: "HIGHLY RECOMMENDED",
            prosText: [
              "Excellent sound quality",
              "Great battery life",
              "Very comfortable fit",
            ],
            consText: ["No wired mode", "Case is bulky"],
            heroDuration: 210,
            featureDuration: 240,
            reviewsDuration: 240,
            galleryDuration: 240,
            verdictDuration: 210,
            transitionDuration: 25,
            includeGallery: true,
            includeGrid: false,
            audioSrc: "",
            audioVolume: 0.5,
            audioStartFrom: 0,
            audioDurationOverride: 60,
            accentColor: "#FF9900",
            darkColor: "#131921",
            lightColor: "#FFFFFF",
            starColor: "#FFA41C",
            priceColor: "#B12704",
          }}
          component={AmazonShowcase}
        />
        {/* Furniture Transition Demo */}
        <Composition
          id="Furniture"
          width={1920}
          height={1080}
          fps={30}
          durationInFrames={0} // Base: 287+30 = 317, +300 for magnifying glass, +30+400 for video = total 1047 + extra buffer
          schema={FurniturePropsSchema}
          calculateMetadata={calculateFurnitureMetadata}
          defaultProps={{
            imageSrc:
              "https://m.media-amazon.com/images/I/71+4KdDH5jL._SY250_.jpg",
            videoSrc:
              "https://storage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4",
            popupTitle: "Metal Panel Iron Board",
            popupSubtitle: "Heavy Duty | Easy Fold",
            blurAmount: 10,
            pulseScale: 1.2,
            flashIntensity: 0.8,
            flashDuration: 8,
            popupStartFrame: 80,
            popupInDuration: 20,
            popupVisibleForFrames: 175,
            popupOutDuration: 15,
            popupX: 80,
            popupY: 120,
            popupMaxWidth: 600,
            includeMagnifyingGlass: true,
            magnifierX: 67,
            magnifierY: 51,
            magnifierRadius: 250,
            magnificationLevel: 3,
            magnifierBorderWidth: 18,
            magnifierBorderColor: "#00000033",
            magnifierShadowBlur: 25,
            magnifierShadowColor: "rgba(0, 0, 0, 0.4)",
            backgroundZoomStart: 1,
            backgroundZoomEnd: 1.8,
            backgroundZoomDuration: 250,
            magnifyingGlassEasingType: "linear" as const,
            fourPanelDuration: 450,
            transitionDuration: 30,
            popupSequenceDuration: 200,
            magnifyingGlassDuration: 300,
            includeVideo: true,
            videoBackground: true,
            videoStartFrom: 0,
            videoObjectFit: "cover" as const,
            autoCalculateVideoDuration: false,
            videoDuration: 491,
          }}
          component={Furniture}
        />
        {/* Mount any React component to make it show up in the sidebar and work on it individually! */}
        <Composition
          id="Review"
          width={1080}
          height={1920}
          fps={30}
          durationInFrames={1050} // This will be overridden by calculateMetadata
          schema={TwoUpSplitYoutubePropsSchema}
          calculateMetadata={calculateMetadata}
          defaultProps={{
            topSrc:
              "https://resource2.heygen.ai/video/transcode/4dcf206bc5a64e4f9b8b2d4bc0ba000c/vff165e205de349b88659772f39e58b6e/1280x720.mp4?response-content-disposition=attachment%3B+filename%2A%3DUTF-8%27%27Story%2520of%2520Seasons%253A%2520Grand%2520Bazaar.mp4%3B",
            bottomYoutubeUrl: "https://www.youtube.com/shorts/VXu8N4Wm-ic",
            youtubeStartTime: "0",
            youtubeEndTime: "55800",
            downloadedVideoPath: "",
            useDownloadedVideo: false,
            split: 25,
            caption: "Story Of Seasons 🐮🐔",
            topMuted: false,
            borderColor: "#ffffff",
            borderWidth: 8,
            objectFit: "cover",
            captionBgColor: "#ff0000ff",
            captionPadding: "8px 16px",
            captionTextColor: "#ffffff",
            captionFontSize: "80px",
            captionFontWeight: "600",
            captionFontFamily: "Arial, sans-serif",
            captionBorderRadius: "12px",
          }}
          component={TwoUpSplitYoutube}
        />
        {/* Mount any React component to make it show up in the sidebar and work on it individually! */}
        <Composition
          id="Top5Portrait"
          width={1080}
          height={1920}
          fps={30}
          durationInFrames={450}
          schema={TopCountdownPropsSchema}
          defaultProps={{
            title: "Top 5 Games of 2025",
            subtitle: "(Best till last)",
            items: [
              {
                label: "CORAL BUDDIES",
                media:
                  "https://storage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
              },
              {
                label: "BRUTUS",
                media: "https://picsum.photos/id/1011/900/1600.jpg",
              },
              {
                label: "MIDAS",
                media:
                  "https://storage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4",
              },
              {
                label: "CHAOS AGENT",
                media: "https://picsum.photos/id/1005/900/1600.jpg",
              },
              {
                label: "???",
                media:
                  "https://storage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4",
              },
            ],
            startFrame: 10,
            itemInFrames: 14,
            staggerFrames: 70,
            theme: { bg: "#000000", primary: "#ff2c55", text: "#ffffff" },
          }}
          component={TopCountdown}
        />
        {/* WigGlowUp – Social media influencer wig showcase (vertical 9:16) */}
        <Composition
          id="WigGlowUp"
          width={1080}
          height={1920}
          fps={30}
          durationInFrames={900}
          schema={WigGlowUpPropsSchema}
          calculateMetadata={calculateWigGlowUpMetadata}
          defaultProps={{
            brandName: "LUXE HAIR CO.",
            productName: "Brazilian Body Wave",
            tagline: "Your Next Signature Look",
            introTitle: "MY\nREVIEW",
            heroImage:
              "https://m.media-amazon.com/images/I/71poim9nMzL._SY250_.jpg",
            carouselImages: [
              "https://m.media-amazon.com/images/I/71poim9nMzL._SY250_.jpg",
              "https://m.media-amazon.com/images/I/71MkomStCJL._SY250_.jpg",
              "https://m.media-amazon.com/images/I/71jW55oLTVL._SY250_.jpg",
              "https://m.media-amazon.com/images/I/71qHcMtDKdL._SY250_.jpg",
              "https://m.media-amazon.com/images/I/41QKHrIJPQL._SY250_.jpg",
            ],
            galleryImages: [
              "https://m.media-amazon.com/images/I/71poim9nMzL._SY250_.jpg",
              "https://m.media-amazon.com/images/I/71MkomStCJL._SY250_.jpg",
              "https://m.media-amazon.com/images/I/71jW55oLTVL._SY250_.jpg",
              "https://m.media-amazon.com/images/I/71qHcMtDKdL._SY250_.jpg",
              "https://m.media-amazon.com/images/I/41QKHrIJPQL._SY250_.jpg",
              "https://m.media-amazon.com/images/I/71poim9nMzL._SY250_.jpg",
            ],
            features: [
              { icon: "💇‍♀️", label: "100% Human Hair" },
              { icon: "📏", label: '16"-28" Length' },
              { icon: "🔥", label: "Heat Friendly" },
              { icon: "💧", label: "Wash & Restyle" },
              { icon: "✨", label: "Pre-Plucked" },
              { icon: "🎀", label: "HD Lace Front" },
            ],
            colorSwatches: [
              { name: "Natural Black", color: "#1a1a1a" },
              { name: "Dark Brown", color: "#3d2314" },
              { name: "Honey Blonde", color: "#c68e3f" },
              { name: "Burgundy", color: "#722f37" },
              { name: "Ombré", color: "linear-gradient(135deg, #1a1a1a, #c68e3f)" },
            ],
            ctaText: "SHOP NOW",
            ctaSubtext: "Link in Bio 🔗",
            handle: "@luxehairco",
            introDuration: 75,
            heroDuration: 120,
            carouselDuration: 180,
            featureDuration: 120,
            colorDuration: 90,
            galleryDuration: 150,
            outroDuration: 90,
            transitionDuration: 20,
            accentColor: "#FF6B9D",
            accentColor2: "#C084FC",
            accentColor3: "#60A5FA",
            darkBg: "#0A0A0A",
            audioSrc: "",
            audioVolume: 0.8,
            audioStartFrom: 0,
            audioDurationOverride: 30,
          }}
          component={WigGlowUp}
        />
        {/* UnboxingOverview – Influencer couch unboxing/overview (vertical 9:16) */}
        <Composition
          id="UnboxingOverview"
          width={1080}
          height={1920}
          fps={30}
          durationInFrames={900}
          schema={UnboxingOverviewPropsSchema}
          calculateMetadata={calculateUnboxingOverviewMetadata}
          defaultProps={{
            brandName: "UNBOXING",
            productName: "Premium Product Review",
            tagline: "Honest First Impressions",
            mediaItems: [
              {
                src: "https://storage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4",
                type: "video",
                label: "First Look",
                videoStartFrom: 0,
              },
              {
                src: "https://storage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
                type: "video",
                label: "What's Inside",
                videoStartFrom: 0,
              },
              {
                src: "https://m.media-amazon.com/images/I/71poim9nMzL._SY250_.jpg",
                type: "image",
                label: "The Product",
                videoStartFrom: 0,
              },
              {
                src: "https://storage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4",
                type: "video",
                label: "Quality Check",
                videoStartFrom: 0,
              },
              {
                src: "https://m.media-amazon.com/images/I/71MkomStCJL._SY250_.jpg",
                type: "image",
                label: "Final Thoughts",
                videoStartFrom: 0,
              },
            ],
            showIntro: true,
            showOutro: true,
            showProgressBar: true,
            showLabels: true,
            ctaText: "FOLLOW FOR MORE",
            ctaSubtext: "Link in Bio 🔗",
            handle: "@myhandle",
            introDuration: 60,
            mediaDuration: 150,
            outroDuration: 75,
            transitionDuration: 15,
            accentColor: "#FF4D6A",
            accentColor2: "#FFA726",
            darkBg: "#0A0A0A",
            overlayOpacity: 0.35,
            audioSrc: "",
            audioVolume: 1,
            audioStartFrom: 0,
            audioDurationOverride: 0,
          }}
          component={UnboxingOverview}
        />
      </Folder>
      <Folder name="LNDBNK">
        {/* Landing Page Composition - Combines InstagramStory, Footer, and MiniImage */}
        <Composition
          id="Landbank"
          width={1080}
          height={1920}
          fps={30}
          durationInFrames={540}
          schema={LandingPageCompositionPropsSchema}
          calculateMetadata={calculateLandingPageMetadata}
          defaultProps={{
            mainSrc:
              "https://s3.us-east-2.amazonaws.com/dlba-production-bucket/property_images/9446483/IMG_20250811_113757.jpg",
            dateText: "October 27, 2025",
            img01src:
              "https://s3.us-east-2.amazonaws.com/dlba-production-bucket/property_images/9446483/IMG_20250811_113914.jpg",
            img02src:
              "https://s3.us-east-2.amazonaws.com/dlba-production-bucket/property_images/9446483/IMG_20250811_131906.jpg",
            img03src:
              "https://s3.us-east-2.amazonaws.com/dlba-production-bucket/property_images/9446483/IMG_20250811_132505.jpg",
            timeText: "9:00 AM - 5:00 PM",
            footerText: "INVESTMENT OPPORTUNITY",
            headerText: "LIVE AUCTION",
            qrDeeplink: "http://ldbnk.app",
            revealText: "Open house",
            addressText: "5013 28th St Detroit, MI 48210",
            paragraphText:
              "This 1905-built property features 4 bedrooms and 2 bathrooms with 1368 sq ft of living space. Located in the desirable Chadsey Condon neighborhood, this property is now available at auction with a starting bid of $1,000. Recent comparable sales in the area have averaged $148,457, presenting a significant investment opportunity for buyers seeking value-add properties in this growing Detroit community.",
            backgroundColor: "#011226",
            footerBackgroundColor: "#ffffff",
          }}
          component={LandingPageComposition}
        />
      </Folder>
    </>
  );
};

;
    var _remotion_globalVariableA, _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
